<div class="acs-page">
  <!-- Loading State -->
  <div *ngIf="isLoading && !chapterId" class="acs-page__loading">
    <acs-loading-spinner size="large" message="Loading chapter details..."></acs-loading-spinner>
  </div>

  <!-- Error State -->
  <acs-alert 
    *ngIf="error" 
    type="error" 
    title="Error Loading Chapter"
    [message]="error" 
    [dismissible]="true"
    (dismissed)="error = null">
  </acs-alert>


  <!-- Chapter Details -->
  <div *ngIf="chapterId && !isLoading" class="acs-page__content">
    
    <!-- Header Section -->
    <div class="acs-page-header">
      <div class="chapter-detail__header-main">
        <button class="chapter-detail__back-btn" (click)="goBack()">
          <span class="chapter-detail__back-icon">←</span>
          Back to Chapters
        </button>
        
        <div class="acs-page-header__title-section">
          <h1 class="acs-page-header__title">{{ chapterEntity.Name || 'ChapterName' }}</h1>
          <div class="acs-page-header__subtitle">
            <span class="chapter-detail__code">{{ chapterEntity.CommitteeID || 'ChapterID' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Summary Cards -->
    <acs-summary 
      [summaryCards]="summaryCards"
      [gridColumns]="4"
      cardSize="medium"
      spacing="normal" />

    <!-- Data Section -->
    <div class="chapter-detail__data-section">
      <!-- Data Type Selector Cards -->
      <div class="chapter-detail__data-selectors">
        <div 
          class="chapter-detail__data-card"
          [class.chapter-detail__data-card--active]="activeTab === 'members'"
          (click)="onTabChange('members')">
          <div class="chapter-detail__data-card-icon">👥</div>
          <div class="chapter-detail__data-card-content">
            <div class="chapter-detail__data-card-title">Members</div>
            <!-- <div class="chapter-detail__data-card-count">{{ members.length }}</div> -->
            <div class="chapter-detail__data-card-description">Chapter membership roster</div>
          </div>
        </div>

        <div 
          class="chapter-detail__data-card"
          [class.chapter-detail__data-card--active]="activeTab === 'officers'"
          (click)="onTabChange('officers')">
          <div class="chapter-detail__data-card-icon">👑</div>
          <div class="chapter-detail__data-card-content">
            <div class="chapter-detail__data-card-title">Officers</div>
            <!-- <div class="chapter-detail__data-card-count">{{ officers.length }}</div> -->
            <div class="chapter-detail__data-card-description">Leadership positions</div>
          </div>
        </div>

        <div 
          class="chapter-detail__data-card"
          [class.chapter-detail__data-card--active]="activeTab === 'dues'"
          (click)="onTabChange('dues')">
          <div class="chapter-detail__data-card-icon">💰</div>
          <div class="chapter-detail__data-card-content">
            <div class="chapter-detail__data-card-title">Dues Records</div>
            <!-- <div class="chapter-detail__data-card-count">{{ duesRecords.length }}</div> -->
            <div class="chapter-detail__data-card-description">Member dues and payments</div>
            <!-- <div class="chapter-detail__data-card-summary" *ngIf="duesRecordSummary">
              <small>{{ (duesRecordSummary.collectionRate || 0).toFixed(1) }}% collected</small>
            </div> -->
          </div>
        </div>
      </div>
      
      <!-- Single Data Grid Display -->
      <div class="acs-grid-section">
        <div class="acs-grid-section__header">
          <h2 class="acs-grid-section__title">{{gridTitle}}</h2>
          <p class="acs-grid-section__description">{{gridDescription}}</p>
        </div>

        <div class="acs-grid-section__container">
          <acs-data-grid
            [serverSide]="true"
            #grid
            [entityName]="entityName"
            [columns]="gridColumns"
            [pageSize]="50"
            [currentPage]="1"
            [enableDropdownFilters]="true"
            [showPagination]="true"
            [showPageSizeSelector]="true"
            [pageSizeOptions]="[25, 50, 100, 250]"
            [sortable]="true"
            [filterable]="true"
            [serverSideFilters]="serverSideFilters"
            [searchable]="true"
            searchPlaceholder="Search records"
            [selectable]="'none'"
            [exportable]="true"
            [exportFilenamePrefix]="entityName"
            [stickyHeader]="true"
            [autoLoad]="true"
            [emptyText]="'No ' + entityName +' records found'"
            (serverError)="onServerDataError($event)" >
          </acs-data-grid>
        </div>
      </div>
    </div>

  </div>
</div>